import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/complexRacer.css';
// components
import Racer from '../components/racer';
// actions
import {addMultiBetSelection, removeMultiBetSelection} from '../../../../modules/racing/actions/raceCardActions';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        selectedEventMultiBetList: state.vpp.selectedEventMultiBetList
    };
};

class ComplexRacer extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState(
            {
                events: storeData.vpp.events,
                selectedEventId: storeData.vpp.selectedEventId,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                selectedRacingBetType: storeData.vpp.selectedRacingBetType,
                selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList
            }
        );
    }

    render() {
        let isSelected = this.state.selectedEventMultiBetList.find((mb) => mb === this.props.racer.num);

        return (
            <div
                className={`${style.button} ${isSelected
                    ? style.selected
                    : ''}`}
                onClick={() => this.props.store.dispatch(
                    isSelected
                        ? removeMultiBetSelection(this.props.racer.num)
                        : addMultiBetSelection(this.props.racer.num, this.state.selectedEventMultiBetList)
                )}>
                <Racer racer={this.props.racer}
                       store={this.props.store}/> {/* <div className={`${style.button}`}>{oddsText}</div> */}
            </div>

        );
    }
}

export default connect(mapStateToProps)(ComplexRacer);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/modules/racing/components/complexRacer.js